import { Property } from '@propertypal/shared/src/types';
import trackEvents from '@propertypal/shared/src/utils/trackEvents';
import router from 'next/router';
import React, { FunctionComponent } from 'react';
import WhiteButton from '../buttons/WhiteButton';
import { InfoBox } from '../layout/InfoBox';
import { Overlay, TextBox } from './PropertyDescription.style';

interface Props {
  property: Property;
}

const MAX_HEIGHT = 300;

const PropertyDescription: FunctionComponent<Props> = (props) => {
  if (!props.property.description || props.property.featuredDevelopmentContent?.hideAdditionalInfo) {
    return null;
  }

  const handleClick = () => {
    trackEvents({
      eventType: 'READ_MORE',
      property: props.property.type === 'property' ? props.property.id : undefined,
      development: props.property.type === 'development' ? props.property.id : undefined,
      eventPageType: props.property.type === 'development' ? 'DEVELOPMENT_DETAILS' : 'PROPERTY_DETAILS',
    });
    router.push(`${props.property.path}/description`, undefined, { shallow: true });
  };

  return (
    <InfoBox title="Additional Information" containerStyle={{ margin: '30px 0' }}>
      <div style={{ position: 'relative' }}>
        <TextBox
          dangerouslySetInnerHTML={{ __html: props.property.description }}
          style={{ minHeight: 100, maxHeight: MAX_HEIGHT }}
        />
        <Overlay />
      </div>

      <WhiteButton
        testID="description-read-more"
        containerStyle={{ margin: '0 0 30px', maxWidth: 180 }}
        onClick={handleClick}
      >
        Read More
      </WhiteButton>
    </InfoBox>
  );
};

export default PropertyDescription;
